import axios from 'axios'
import { orderUtils } from '../../utils/orderUtils'

export default {
    namespaced: true,
    state: {
        orders : []
    },
    getters: {
    },
    mutations: {
        FETCH_ORDERS(state, orders) {
            state.orders = orders
        },
        CLOSE_ORDER(state, id) {
            const index = state.orders.findIndex(order => Number(order.id) === id);
            state.orders.splice(index, 1);
        },
        NEW_ORDER(state, newOrder) {
            state.orders.push(newOrder)
        },
        EDIT_ORDER(state, editOrder) {
            let index = state.orders.findIndex(order => Number(order.id) === Number(editOrder.id));
            state.orders.splice(index, 1, editOrder)
        }
    },
    actions: {
        fetch({commit, rootState, dispatch, state}, payload) {
            return new Promise((resolve, reject) => {
                if (state.orders.length) {
                    resolve(state.orders)
                } else {
                    axios.get('/api/mixins/orders/list', { params: payload}).then(({data}) => {
                        commit('FETCH_ORDERS', data.data)
                        resolve(data.data)
                    }).catch((error) => {
                        dispatch('checkUnauthenticated', error, { root: true })
                        reject(error)
                    })
                }
            })
        },
        completeOrder({commit, dispatch}, orderId) {
            return new Promise((resolve) => {
                axios.put('/api/mixins/orders/complete/' + orderId).then(() => {
                    commit('CLOSE_ORDER', orderId)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
        addOrder({ commit, dispatch, rootState }, payload) {
            let order = orderUtils.prepareOrderBeforeSave(
                rootState.setting.settings,
                payload
            )
            order.time_reaction = new Date()
            order.date_work = new Date()
            order.status = 1
            order.condition = 0
            order.hotel_id = rootState.auth.currentHotel.id

            return new Promise((resolve) => {
                axios.post('/api/mixins/orders/add', order).then(({data}) => {
                    commit('NEW_ORDER', data.data)
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        editOrder({ commit, dispatch, rootState }, payload) {
            let order = orderUtils.prepareOrderBeforeSave(
                rootState.setting.settings,
                payload
            )
            order.status = 1
            order.date_work = new Date()
            return new Promise((resolve) => {
                axios.post('/api/mixins/orders/edit/' + Number(payload.id), order)
                    .then(({data}) => {
                        commit('EDIT_ORDER', data.data)
                        resolve(data.data)
                    }).catch((error) => {
                        dispatch('checkUnauthenticated', error, { root: true })
                    })
            })
        },
        cancelOrder({commit, dispatch}, payload) {
            return new Promise((resolve) => {
                axios.post('/api/mixins/orders/delete-order/' + payload.id, {
                    text: payload.text
                }).then(({data}) => {
                    commit('CLOSE_ORDER', payload.id)
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
        completedFetchClient({commit, dispatch}, filter) {
            return new Promise((resolve, reject) => {
                commit('TOGGLE_PRELOADER', true, {root: true})
                axios.get(
                    '/api/manager/orders/complete/list',
                    { params: filter }
                ).finally(() => {
                    commit('TOGGLE_PRELOADER', false, {root: true})
                }).then(({data}) => {
                    resolve(data.data)
                }).catch(error => {
                    dispatch('checkUnauthenticated', error, { root: true })
                    reject(error)
                })
            })
        },
        completedFetchConsolidated({commit, dispatch}, filter) {
            commit('TOGGLE_PRELOADER', true, {root: true})
            return axios.get(
                '/api/manager/orders/complete/consolidated',
                { params: filter }
            ).finally(() => {
                commit('TOGGLE_PRELOADER', false, {root: true})
            }).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
        getListOrders({commit, dispatch}, filter) {
            return new Promise((resolve, reject) => {
                commit('TOGGLE_PRELOADER', true, {root: true})
                axios.get(
                    '/api/administrator/orders/',
                    { params: filter }
                ).then(({data}) => {
                    resolve(data.data)
                }).finally(() => {
                    commit('TOGGLE_PRELOADER', false, {root: true})
                }).catch(error => {
                    dispatch('checkUnauthenticated', error, { root: true })
                    reject(error)
                })
            })
        },
    }
}
